import {Store,Module,ActionContext} from 'vuex'
import {ListModule, ListState,ListMutations, ListStateItem, ListModuleItem} from '@/store/shared'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

import EstimatedExchangeRate from './entity'
import Tree from "@/store/shared/entity/tree";

interface EstimatedExchangeRateState extends ListStateItem<EstimatedExchangeRate>{
    editEstimatedExchangeRate:EstimatedExchangeRate,
}

class EstimatedExchangeRateModule extends ListModuleItem<EstimatedExchangeRateState,any,EstimatedExchangeRate>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={
        editEstimatedExchangeRate:new EstimatedExchangeRate(),
    }
    actions={
        async getAll(context:ActionContext<EstimatedExchangeRateState,any>,payload:any){
            context.state.table.loading=true;
            let reponse=await $http.get('services/app/EstimatedExchangeRate/GetAll',{params:payload.data});
            context.state.table.loading=false;
            let page=reponse.data.result as PageResult<EstimatedExchangeRate>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
        },
        async create(context:ActionContext<EstimatedExchangeRateState,any>,payload:any){
            await $http.post('services/app/EstimatedExchangeRate/Create',payload.data);
        },
        async update(context:ActionContext<EstimatedExchangeRateState,any>,payload:any){
            await $http.put('services/app/EstimatedExchangeRate/Update',payload.data);
        },
        async delete(context:ActionContext<EstimatedExchangeRateState,any>,payload:any){
            await $http.delete('services/app/EstimatedExchangeRate/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<EstimatedExchangeRateState,any>,payload:any){
            let reponse=await $http.get('services/app/EstimatedExchangeRate/Get?Id='+payload.id);
            return reponse.data.result as EstimatedExchangeRate;
        },
    };
    overrideMutations={
        edit(state:EstimatedExchangeRateState,estimatedexchangerate:EstimatedExchangeRate){
            state.editEstimatedExchangeRate=estimatedexchangerate;
        }
    }
}
const estimatedExchangeRateModule=new EstimatedExchangeRateModule();
export default estimatedExchangeRateModule;